import { getMiembros, MiembrosDTO } from '../../api/miembros/getMiembros';
import { GenericState } from '../../types/apiModule';
import { LinksPage, PageInfo } from '../../types/pagination/pagination';
import { Miembro } from '../../types/users/users';
import createApiModule from '../createApiModule';
import { t } from '../../i18n';

export interface MiembroModule extends GenericState<unknown> {
  data: MiembrosDTO;
}

const initialState: MiembroModule = {
  errors: null,
  loading: false,
  data: {
    data: [] as Miembro[],
    links: {} as LinksPage,
    meta: {} as PageInfo,
  },
};

const listMiembroModule = createApiModule({
  name: 'listMiembros',
  apiMethod: getMiembros,
  initialState,
  parse: (organizaciones) => organizaciones,
  onSuccess: () => {},
  onError: () => ({
    message: t('StoreMiembrosListMiembrosModuleErrorListandoLosMiembros'),
  }),
  onValidationError: () => {},
});

export const {
  start: listMiembros,
  success: listMiembrosOk,
  error: listMiembrosKo,
  refresh: listMiembrosRefresh,
  reset: listMiembrosReset,
} = listMiembroModule.slice.actions;

export const { sagas } = listMiembroModule;

export default listMiembroModule;
